<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Υπηρεσίες Αποδείξεων</h4>
          <CButton class="m-3" color="primary" @click="createService()">Δημιουργία υπηρεσίας</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CDataTable
            :items="items"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            :loading="loading"
            sorter
          >
          <template #edit="{item}">
            <td>
              <CButton color="primary" @click="editService( item.id )">Επεξεργασία</CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

const fields = [
  {
    key: 'name', 
    label: 'Όνομα', 
    sorter: true, 
    filter: true
  },
  { 
    key: 'edit', 
    label: '', 
    sorter: false, 
    filter: false
  }
]

export default {
  name: 'ReceiptServices',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      message: '',
      loading: true,
      alertIsShown: false,
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    editLink (id) {
      return `receipt_services/${id.toString()}/edit`
    },
    editService ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getServices (){
      let self = this;
      axios.get('/api/receiptservices?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.services;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
    createService () {
      this.$router.push({path: 'receipt_services/create'});
    },
  },
  mounted: function(){
    this.getServices();
  }
}
</script>
